import type { PdfEngine, PdfEngineOptions } from "@pdfking/pdfengine"
import fail from "../utils/fail"

export const EngineCache = {}

export const Engine: PdfEngine = {
  CreateRemoteFile: fail,
  config: {} as PdfEngineOptions,
  DownloadFile: fail,
  GenerateFile: fail,
  MergePdf: fail,
  PlotPdf: fail,
  RasterizePdf: fail,
  RequestBlob: fail,
  SplitPdf: fail,
  ZipFiles: fail,
}

export const CreateRemoteFile = fail
